module.exports = __webpack_public_path__ + "static/media/failureIcon.061918e9.svg";